import React, { useEffect, useState } from 'react'
import { Button, Center, Select, useDisclosure, FormLabel, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useToast } from '@chakra-ui/react'
import axios from 'axios';


function ModalNewReferent() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [user_id, setUser_id] = useState("");
    const [lycee_id, setLycee_id] = useState("");
    const access_level = 5;

    const [users, setUsers] = useState([]);
    const [lycees, setLycees] = useState([]);
    const toast = useToast();

   

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axios.get( `${process.env.REACT_APP_API_URL_}/users/` );
                setUsers(response.data.filter(user => user.role === "admin"));
                
            } catch (error) {
                toast({
                    title: "Erreur",
                    description: "Une erreur est survenue lors de la récupération des utilisateurs.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            }
        };
    
        const fetchLycee = async () => {
            try {
                const response = await axios.get( `${process.env.REACT_APP_API_URL_}/lycees/`);
                setLycees(response.data);
            } catch (error) {
                toast({
                    title: "Erreur",
                    description: "Une erreur est survenue lors de la récupération des lycées.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            }
        };
        fetchUser();
        fetchLycee();
    }, [toast]);

    const handleCreatePerm = async () => {
        try {
            await axios.post( `${process.env.REACT_APP_API_URL_}/perms/`, {user_id, lycee_id, access_level});
            toast({
                title: "Permission ajoutée",
                description: "La permission a bien été ajoutée.",
                status: "success",
                duration: 5000,
                isClosable: true,
            });
            onClose();
        } catch (error) {
            toast({
                title: "Erreur",
                description: "Une erreur est survenue lors de l'ajout de la permission.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };




    return (
      <>
      <Center>
        <Button mt={5} onClick={onOpen}>Ajouter un Référent</Button>
        </Center>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Ajout d'un référent</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <FormLabel>Utilisateur</FormLabel>
                <Select mb={3} onChange={e => setUser_id(e.target.value)}>
                    <option value="option1">Choix de l'user</option>
                    {users.map((user) => (
                        <option key={user.user_id} value={user.user_id}>{user.email}</option>
                    ))}
                </Select>
                <FormLabel>Lycée</FormLabel>
                <Select mb={3} onChange={e => setLycee_id(e.target.value)}>
                    <option value="option1">Choix du lycée</option>
                    {lycees.map((lycee) => (
                        <option key={lycee.lycee_id} value={lycee.lycee_id}>{lycee.name}</option>
                    ))}
                </Select>
            </ModalBody>
  
            <ModalFooter>
              <Button colorScheme='red' mr={3} onClick={onClose}>
                Annuler
              </Button>
              <Button variant='ghost' onClick={handleCreatePerm}>Valider</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }
  export default ModalNewReferent;
